module.exports = __webpack_public_path__ + "static/media/login_banner.4eaa9fe2.svg";